<template>
	<div class="marketing-section">
		<div class="container">
			<div>
				<h2 class="heading-1 mb-150 col-7-md"> The arc of financial history bends toward democracy </h2>
				<div class="body-medium col-8-md">
					<p>
						When we started Fundrise, institutions asked us, “Why bother with the little guy?” Private
						markets had always been exclusive to institutional and high net worth investors. Closed to 95%+
						of individuals.
					</p>
					<p>
						What they didn’t understand is that democracy is inseparable from technology. Expanding access
						drives technological progress, which drives even greater access. Open markets win over closed
						markets.
					</p>
					<p>
						The past 100 years of public markets have been a virtuous cycle of technology and democracy. The
						history of public markets is the future of private markets.
					</p>
				</div>
			</div>
			<img v-lazy="img" alt="Key innovations in the U.S stock market chart" class="mt-200-md mt-300-smo" />
			<div class="display-flex-md justify-content-center-md mt-100">
				<p class="text-align-center body-xs text-color-content-tertiary col-8-md">
					Sources: NYSE shareownership census for pre-1971 (before the NASDAQ was founded). 1980 - 1989
					estimates based on US population and Federal Reserve Survey of Consumer Finances. 2000 and onward
					estimates based on US population and Gallup poll results.
				</p>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { appCloudfrontPath } from '@constants';
import { computed } from 'vue';
import { useAppStore } from '@stores/app';

const appStore = useAppStore();

const img = computed((): string => {
	return `${appCloudfrontPath}/images/offerings/fundrise-ipo/key-innovations-in-the-us-stock-market-${
		appStore.isMobile ? 'mobile' : 'desktop'
	}.png`;
});
</script>
